import i18next from "i18next"
import en from "./en.json"
import vi from "./vi.json"

const initLanguage = typeof window !== "undefined" ? document?.documentElement?.lang : "en"

i18next.init({
  interpolation: { escapeValue: false },
  lng: initLanguage,
  resources: {
    vi: {
      translation: vi,
    },
    en: {
      translation: en,
    },
  },
})

const t = (key: string, options?: any) => i18next.t(key, JSON.stringify(options)).toString()
export { t }
